<template>
    <MiscImage
        v-if="mainImage"
        :lazy-load="lazyload ? lazyload : true"
        :preload="props.preload ? true : null"
        provider="none"
        :src="mainImage?.url"
        :srcset="imageSrcset"
        :alt="media.alt"
        :title="media.title"
        fit="fit"
        class="cms-image"
        width="100"
        height="100"
    />
</template>

<script setup lang="ts">
import {computed, ref} from 'vue'
import type { HblThumbnail } from '@/utils/types'

const props = defineProps<{
    media?: any,
    preload?: boolean
    lazyload?: boolean
}>()

const getMedia = computed(() => {
    return props.media
})

const mediaUrl = computed(() => {
    return getMedia.value && getMedia?.value?.url
})

const mainImage = ref(Array.isArray(props.media) ? props.media[0] : props.media);

const imageSrcset = computed(() => {
    return mainImage?.value?.thumbnails
        ?.map((thumb: { url: any; width: any; }) => `${thumb.url.replace(/\s/g, '%20')} ${thumb.width}w`)
        .join(', ');
});

function getMediaUrl(width: number) {
    if (!getMedia.value) {
        return '/';
    }

    let image = mediaUrl.value;

    if (width != null) {
        getMedia.value.thumbnails.forEach((thumbnail: HblThumbnail) => {
            if (thumbnail.width === width) {
                image = thumbnail.url;
            }
        });
    }

    return image;
}

if (props.preload) {
    useHead({
        link: [
            {
                rel: 'preload',
                as: 'image',
                href: props.media?.url,
                imagesrcset: getMediaUrl(1920) + ' 1921w, ' + getMediaUrl(1920) + ' 1920w, ' + getMediaUrl(800) + ' 800w, ' + getMediaUrl(400) + ' 400w'
            }
        ]
    })
}
</script>
